export default __webpack_public_path__ + "static/media/1(1).9837d2b1.jpg";